import { render } from "./AppSidebar.vue?vue&type=template&id=912cd194&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=912cd194&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/FrontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-912cd194"]])

export default __exports__